import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Holidays.api';

export const getHolidaysRequest = () => ({
  type: actionTypes.GET_HOLIDAYS_REQUEST,
});

export const getHolidaysSuccess = (holidays) => ({
  type: actionTypes.GET_HOLIDAYS_SUCCESS,
  payload: holidays,
});

export const getHolidaysFailure = (error) => ({
  type: actionTypes.GET_HOLIDAYS_FAILURE,
  payload: error,
});

export const getHolidays = (year) => {
  console.log("Fetching holidays for year:", year);

  return async (dispatch) => {
    dispatch(getHolidaysRequest(year));
    try {
      const holidays = await api.fetchHolidaysData(year);
      dispatch(getHolidaysSuccess(holidays));
      return { success: true, data: holidays };
    } catch (error) {
      dispatch(getHolidaysFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateHolidaysRequest = (id, holidaysData) => ({
  type: actionTypes.UPDATE_HOLIDAYS_REQUEST,
  payload: { id, holidaysData },
});

export const updateHolidaysSuccess = (message) => ({
  type: actionTypes.UPDATE_HOLIDAYS_SUCCESS,
  payload: message,
});

export const updateHolidaysFailure = (error) => ({
  type: actionTypes.UPDATE_HOLIDAYS_FAILURE,
  payload: error,
});

// Function to handle holiday updates
export const updateHolidaysById = (id, holidaysData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    holidaysData.updated_by = user.user_name;

    dispatch(updateHolidaysRequest(id, holidaysData));
    try {
      const response = await api.updateHolidays(id, holidaysData);
      dispatch(updateHolidaysSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Error updating holiday';
      dispatch(updateHolidaysFailure(errorMessage));
      return { success: false, message: errorMessage };
    }
  };
};


export const deleteHolidaysRequest = (id) => ({
  type: actionTypes.DELETE_HOLIDAYS_REQUEST,
  payload: id,
});

export const deleteHolidaysSuccess = (message) => ({
  type: actionTypes.DELETE_HOLIDAYS_SUCCESS,
  payload: message,
});

export const deleteHolidaysFailure = (error) => ({
  type: actionTypes.DELETE_HOLIDAYS_FAILURE,
  payload: error,
});

export const deleteHolidaysById = (id) => {
  return async (dispatch) => {
    dispatch(deleteHolidaysRequest(id));
    try {
      const response = await api.deleteHolidays(id);
      dispatch(deleteHolidaysSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteHolidaysFailure(error));
      return { success: false, message: error };
    }
  };
};



export const uploadHolidaysRequest = (fileData) => ({
  type: actionTypes.UPLOAD_HOLIDAYS_REQUEST,
  payload: fileData,
});

export const uploadHolidaysSuccess = (message) => ({
  type: actionTypes.UPLOAD_HOLIDAYS_SUCCESS,
  payload: message,
});

export const uploadHolidaysFailure = (error) => ({
  type: actionTypes.UPLOAD_HOLIDAYS_FAILURE,
  payload: error,
});

export const uploadHolidaysFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadHolidaysRequest(fileData));
    try {
      const response = await api.HolidaysUpload(fileData);
      dispatch(uploadHolidaysSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadHolidaysFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteHolidaysRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_HOLIDAYS_REQUEST,
  payload: ids,
});

export const multiDaleteHolidaysSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_HOLIDAYS_SUCCESS,
  payload: message,
});

export const multiDaleteHolidaysFailure = (error) => ({
  type: actionTypes.MULTIDELETE_HOLIDAYS_FAILURE,
  payload: error,
});

export const multiDeleteHolidays = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteHolidaysRequest(ids));
    try {
      const response = await api.multiDeleteHolidays(ids);
      dispatch(multiDaleteHolidaysSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteHolidaysFailure(error));
      return { success: false, message: error };
    }
  };
};


